<script>
    import DefaultComponent from '../defaultComponent';

    export default {
        ...DefaultComponent,
        props: {
            ...DefaultComponent.props,
            citelabel: String,
            copiedlabel: String,
        },
        computed: {
            ...DefaultComponent.computed,
            editors() {
                return this.item.editors && this.item.editors.length ? this.item.editors.map(name => this.formatToScientificNotation(name)).join(', ') : '';
            },
            citationEditors() {
                return this.editors ? this.editors + ', ' : '';
            },
            citationBook() {
                let pages = this.item.pages ? ` pp. ${this.item.pages}` : '';
                return this.item.bookTitle ? `<i>${this.item.bookTitle}</i>${pages}.` : '';
            },
            citationLocation() {
                return this.item.location ? ` ${this.item.location}.` : '';
            },
            citation() {
                return `<p>${this.citationEditors}${this.item.title}. ${this.citationBook} ${this.item.year}.${this.citationLocation}</p>`;
            },
        },
        methods: {
            formatToScientificNotation(name) {
                let trimmedName = name.trim();
                if (trimmedName.includes(',') || trimmedName.includes('.')) return fullName;

                const nameParts = trimmedName.trim().split(' ');
                const lastName = nameParts.pop();
                const initials = nameParts.map(name => name[0].toUpperCase()).join('.');
                return `${lastName}, ${initials}.`;
            },
            async copyToClipboard() {
                const tempElement = document.createElement('div');
                tempElement.innerHTML = this.citation;
                document.body.appendChild(tempElement);
                const range = document.createRange();
                range.selectNodeContents(tempElement);
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);

                try {
                    document.execCommand('copy');
                } catch (execErr) {
                    console.error('Copy failed:', execErr);
                } finally {
                    document.body.removeChild(tempElement);
                }

                this.$refs.notification.classList.add('is-shown');
                setTimeout(() => this.$refs.notification.classList.remove('is-shown'), 2000);
            },
        }
    }
</script>

<template>
    <a :href="url" target="_blank" class="card publicationlink is-shadowless">
        <div :class="['card-content', 'is-flex-grow-1', 'is-flex', 'is-flex-direction-column', contentClass]">
            <p v-show="editors" :class="['has-text-grey-darker', 'mb-2', textClass]">{{ editors }}</p>
            <h3 v-show="item.title" :class="['title', titleClass]" v-html="item.title"></h3>
            <p :class="['has-text-grey-darker']"><span v-html="citationBook"></span> ({{ item.year }}) {{ citationLocation }}</p>
            <div v-if="!inSidebar" class="buttons mt-auto is-align-self-flex-end is-relative">
                <button class="button is-info is-outlined no-hover" @click.prevent.stop="copyToClipboard">
                    <span class="icon"><i class="fa-solid fa-quote-left"></i></span>
                    <span>{{ citelabel }}</span>
                </button>
                <div class="notification is-light is-size-body p-3 is-nowrap" ref="notification">{{ copiedlabel }}</div>
            </div>
        </div>
    </a>
</template>
